import { useNavigate } from "react-router-dom";
import { Zap, X, Clock, ImageOff } from "lucide-react";

const MESSAGES = {
  trial_expired: {
    icon: Clock,
    title: "Your free trial has ended",
    body: "You've used your 7-day trial. Subscribe to keep creating and publishing LinkedIn posts.",
    buttonText: "Upgrade to Pro — $19.99/mo",
  },
  daily_limit_reached: {
    icon: Clock,
    title: "Daily limit reached",
    body: "You've used 5 posts today. Come back tomorrow, or upgrade for unlimited access.",
    buttonText: "Upgrade to Pro — $19.99/mo",
  },
  upgrade_required: {
    icon: ImageOff,
    title: "Ultra feature",
    body: "AI image generation is available on the Ultra plan ($49.99/mo). Upgrade to create images and infographics for your posts.",
    buttonText: "Upgrade to Ultra — $49.99/mo",
  },
};

/**
 * Modal overlay shown when a gated action returns a 403.
 * Props:
 *   code: "trial_expired" | "daily_limit_reached" | "upgrade_required"
 *   onClose: () => void
 */
export default function UpgradePrompt({ code, onClose }) {
  const navigate = useNavigate();
  const msg = MESSAGES[code] || MESSAGES.upgrade_required;
  const Icon = msg.icon;

  const handleUpgrade = () => {
    onClose?.();
    navigate("/pricing");
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4"
      onClick={(e) => e.target === e.currentTarget && onClose?.()}
    >
      <div className="w-full max-w-sm rounded-2xl bg-card border border-border shadow-xl p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex flex-col items-center text-center gap-4">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon className="w-6 h-6 text-primary" />
          </div>

          <div>
            <h2 className="text-base font-semibold mb-1">{msg.title}</h2>
            <p className="text-sm text-muted-foreground">{msg.body}</p>
          </div>

          <button
            onClick={handleUpgrade}
            className="w-full flex items-center justify-center gap-2 rounded-lg bg-primary text-primary-foreground px-4 py-2.5 text-sm font-semibold hover:bg-primary/90 transition-colors"
          >
            <Zap className="w-4 h-4" />
            {msg.buttonText}
          </button>

          {code === "daily_limit_reached" && (
            <button
              onClick={onClose}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Come back tomorrow
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
